<div class="toast-container position-fixed bottom-0 end-0 p-3">
  @for (toast of toasts(); track $index) {
    <edportal-toast [toastConfig]="toast" />
  }
</div>
